import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, ParamMap, Router } from '@angular/router';
import { SessionService } from '../core/session/session.service';
import { Msisdn } from '../shared/models/msisdn';
import { IdentifierType, MemberIdentifier } from '../core/_models/member-interface';

import { AUTOLOGIN_ENCODED_MSISDN_QUERY_PARAM, REDIRECT_QUERY_PARAM } from '@app/core/consts';
import { NEW_PROFILE_PATH } from '@app/+profile-form/profile-routes';
import { MEMBER_PAGE_PATH } from '@app/consts';


@Injectable()
export class LoginService {
  private redirectionRoute: string | null = null;
  private form: any;

  constructor(private router: Router,
              private sessionService: SessionService) {
  }

  public checkIfMemberBasicallyAuthenticated(route: ActivatedRoute): void {
    this.sessionService.isBasicallyAuthenticated()
      .subscribe((isAuthenticated) => {
        if (isAuthenticated) {
          this.afterSignedIn(route);
        }
      });
  }

  public parseQueryParams(params: ParamMap, loginControl: AbstractControl | null, identifiers: string[] | undefined): void {
    const encodedMsisdn = Msisdn.decodeMsisdn(params.get(AUTOLOGIN_ENCODED_MSISDN_QUERY_PARAM) || params.get('msisdn') || '');
    let email = params.get('email');
    email = email ? email.trim() : email;

    if (encodedMsisdn && (!identifiers || identifiers[0] === IdentifierType.MSISDN)) {
      loginControl?.patchValue(encodedMsisdn);
    }
    if (email && identifiers?.[0] === IdentifierType.EMAIL) {
      loginControl?.patchValue(email);
    }

    this.form = params.get('form');
    this.redirectionRoute = params.get(REDIRECT_QUERY_PARAM);
  }

  public afterSignedIn(route: ActivatedRoute | null): void {
    this.redirectionRoute ? this.navigateToUrl() : this.navigateToMemberPage(route);
  }

  public navigateToNewProfile(memberIdentifier: MemberIdentifier, route: ActivatedRoute): void {
    const params = { [memberIdentifier.identifier_type]: memberIdentifier.identifier, form: this.form };

    if (params[IdentifierType.MSISDN]) {
      params[IdentifierType.MSISDN] = Msisdn.encodeMsisdn(params[IdentifierType.MSISDN]);
    }
    params.target = route.snapshot.queryParamMap.get('target');

    const navigationExtras: NavigationExtras = { queryParams: params, relativeTo: route };
    this.router.navigate(['.', 'profile', NEW_PROFILE_PATH], navigationExtras);
  }

  private navigateToMemberPage(route: ActivatedRoute | null): void {
    this.router.navigate(['.', MEMBER_PAGE_PATH], { relativeTo: route, replaceUrl: true });
  }

  private navigateToUrl(): void {
    if (this.redirectionRoute) {
      this.router.navigateByUrl(this.redirectionRoute, {
        replaceUrl: true,
      });
    }
    this.redirectionRoute = null;
  }
}
